'use client';

import React, { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import BuyPage from './buy/page';
import HPPrinterSetupPage from './hpprintersetup/page';

const supabase = createClient(
  process.env.NEXT_PUBLIC_SUPABASE_URL!,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
);

export default function HomePage() {
  const [homePage, setHomePage] = useState<string | null>(null);

  useEffect(() => {
    async function fetchSetting() {
      const { data } = await supabase
        .from('site_settings')
        .select('home_page')
        .eq('id', 'global')
        .single();

      setHomePage(data?.home_page ?? 'store');
    }
    fetchSetting();
  }, []);

  if (homePage === null) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
        <div style={{ width: '40px', height: '40px', border: '4px solid #bfdbfe', borderTopColor: '#2563eb', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (homePage === 'hpprintersetup') {
    return <HPPrinterSetupPage />;
  }

  return <BuyPage />;
}
